import { msg } from 'gt-react';
import { createRoute } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute } from '../../route';
import { AppsGalleryPage } from './AppsGalleryPage';

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/apps/gallery',
  component: AppsGalleryPage,
  loader: () => ({
    crumb: msg('Apps components', { context: 'page breadcrumb' }),
    crumbDescription: msg(
      'Every component an App view can use, rendered with the Gently theme',
      { context: 'breadcrumb tooltip for the Apps component gallery' },
    ),
  }),
});
